@import 'apps/webcomponents/src/assets/apex-chart.scss';

.chart-container {
  min-height: 210px;
  transform: translateY(-3px);
}

.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
  border-bottom: none;
  background-color: transparent;
  margin-bottom: calc(var(--spacer) * 2);
}

.apexcharts-tooltip {
  border: 10px;
  padding: calc(2 * var(--spacer)) calc(3 * var(--spacer));
  background: var(--white-layout-303-level-2-elevation) !important;
  color: var(--body-text-arrows-400);
  min-width: 220px;

  .tooltip {
    background-color: var(--white-layout-303-level-2-elevation);
    color: var(--body-text-arrows-400);
    padding: calc(2 * var(--spacer)) calc(3 * var(--spacer));
    font-size: var(--body-size);
    white-space: normal;

    &--value {
      font-weight: bold;
    }
  }
}

.apexcharts-tooltip-marker {
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-right: var(--spacer);
  border-radius: 0;
}

.apexcharts-tooltip-y-group {
  padding: 4px 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  .apexcharts-tooltip-text {
    &-y-label {
      font-family: var(--font-family-secondary);
      font-size: var(--body-size-medium);
    }
    &-y-value {
      font-family: var(--font-family-secondary-mono);
      font-weight: 700;
    }
  }
}
.apexcharts-tooltip-series-group {
  padding: 0;
}

.apexcharts-tooltip-title {
  color: var(--chart-300-icon-buttons);
}

.apexcharts-tooltip-text {
  width: 100%;
  color: var(--main-titles-inputs-600);
}

.apexcharts-tooltip-text-y-value {
  color: var(--main-titles-inputs-600);
}

.apexcharts-tooltip-text-label {
  flex: 1;
}

.apexcharts-legend-series {
  margin-right: calc(var(--spacer) * 4) !important;

  &:last-of-type {
    margin-right: 0 !important;
  }

  .apexcharts-legend-marker {
    margin-right: var(--spacer);
    cursor: auto;
  }

  .apexcharts-legend-text {
    font-size: var(--body-size-large) !important;
    font-family: var(--font-family-secondary) !important;
    color: var(--main-titles-inputs-600) !important;
  }
}

.apexcharts-gridlines-vertical {
  .apexcharts-gridline {
    &:last-of-type {
      transform: translateX(-3px);
    }
  }
}
.apexcharts-grid-borders,
.apexcharts-gridlines-horizontal {
  .apexcharts-gridline {
    stroke: var(--chart-101-pressed-dividers);
  }
  line:last-of-type {
    stroke: var(--chart-101-pressed-dividers);
  }
}

.apexcharts-inner {
  .apexcharts-xaxis-tick {
    stroke: var(--chart-101-pressed-dividers);
  }
}

.apexcharts-text {
  &.apexcharts-yaxis-label tspan {
    font-size: var(--body-size-xsmall);
    font-family: var(--font-family-secondary-mono);
    fill: var(--main-titles-inputs-600);
  }
  &.apexcharts-xaxis-label tspan {
    font-size: var(--body-size);
    font-family: var(--font-family-secondary);
    fill: var(--body-text-arrows-400);
  }
}

.apexcharts-xaxis-label {
  width: 50px;
}

.apexcharts-legend {
  padding: 0;
}
